var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-parallax',{attrs:{"dark":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"mb-12 text-center",attrs:{"cols":"12"}},[_c('GChart',{attrs:{"type":"Timeline","data":_vm.chartData,"options":_vm.chartOptions,"settings":{ packages: ['timeline'] }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }